import React from "react";
import { useHistory } from "react-router";
import { useUpdateOnboarding } from "@hooks/app/useUpdateOnboarding";
import { useHelpCentre } from "@hooks/app/useHelpCentre";

const WhatsNewCard = () => {
  const history = useHistory();

  const { dismissed, dismissOnboarding, updateState } = useUpdateOnboarding();
  const { whatsNewSection } = useHelpCentre();

  if (dismissed || !updateState) {
    return null;
  }

  const learnMorePressed = () => {
    if (whatsNewSection) {
      history.push(`/dashboard/help-centre/${whatsNewSection.ID}`, { from: "whats-new-card" });
    } else {
      history.push("/dashboard/help-centre", { from: "whats-new-card" });
    }
  };

  const dismissPressed = () => {
    dismissOnboarding();
  };

  return (
    <div className="py-4 px-3.5 rounded bg-yellow-banner mb-4 dashboard-card-shadow whats-new-border">
      <div className="text-acc-17px font-extrabold text-grey-80 mb-1">
        {whatsNewSection?.["App Onboarding Title"] ?? "What’s new in ParaFolio?"}
      </div>
      <div className="text-acc-17px font-acc-normal leading-acc-lh tracking-default text-grey-90">
        {whatsNewSection?.["App Onboarding Text"] ??
          "We’re continuously working on improving ParaFolio to make it the best CPD tool for you. Read up on our latest release notes as well as upcoming features to help you prepare for audit."}
      </div>
      <div className="flex flex-row justify-end gap-4 mt-4">
        <button
          className="text-17px font-acc-normal tracking-default text-cta-blue"
          onClick={dismissPressed}
        >
          {"Dismiss"}
        </button>
        <button
          className="text-17px font-acc-600 tracking-default text-cta-blue"
          onClick={learnMorePressed}
        >
          {"Learn more"}
        </button>
      </div>
    </div>
  );
};

export default WhatsNewCard;
